export function imagePopup() {
    let popup = $(".image-popup");
    let imageHolder = popup.find(".image-popup-holder");
    $(".photo-popup-opener").on("click", function () {
        let src = $(this).data("src");
        let img = $("<img>");
        img.attr('src', src);
        img.appendTo(imageHolder);
        setTimeout(function () {
            popup.addClass("show");
        }, 500);
    });
    popup.find(".close").on("click", function () {
        popup.removeClass("show");
        setTimeout(function () {
            imageHolder.children().remove();
        }, 500);
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/imagePopup.js